function TableHeader({ data }) {
	return (
		<th data-header={data.heading}>
			{data.heading}
		</th>
	)
}

export default TableHeader